// extracted by mini-css-extract-plugin
export default {"msgM":"_1fe9d5805f"};